/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import Privacy_Section1 from "./sections/Privacy_Section1";

function Privacy() {
  usePageMeta({
    title: "Privacy Policy | Spechs Ireland",
    description:
      "Read the Spechs privacy policy. We are committed to protecting your personal data.",
    canonical: "https://www.spechs.ie/privacy/",
  });
  return (
    <SubPageLayout title="Privacy Policy">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Privacy_Section1 />
      </MKBox>
    </SubPageLayout>
  );
}

export default Privacy;
